/**
 * Wide editing screens open with the page panel closed, so the editor gets the width (Jeff,
 * 2026-10-21, on the Menu Cycle editor: "the second nav should close"). The toggle reopens it for
 * that visit; once the user leaves these screens their own collapse setting applies again.
 */
const WIDE_EDITOR_ROUTES: RegExp[] = [
  /^\/menucycle\/(workbench|basic|analysis|swap)\/[^/]+/,
  /^\/menucycle\/import\/[^/]+/,
];

export function isWideEditorRoute(pathname: string): boolean {
  return WIDE_EDITOR_ROUTES.some((r) => r.test(pathname));
}
